const STATUS_STYLES = {
  "New Order": "bg-zinc-100 text-zinc-700 border-zinc-300",
  "Waiting for Payment": "bg-amber-50 text-amber-700 border-amber-300",
  "Payment Under Review": "bg-blue-50 text-blue-700 border-blue-300",
  "Payment Confirmed": "bg-emerald-50 text-emerald-700 border-emerald-300",
  "Ready to Ship": "bg-indigo-50 text-indigo-700 border-indigo-300",
  "Shipped": "bg-violet-50 text-violet-700 border-violet-300",
  "Delivered": "bg-green-100 text-green-800 border-green-400",
  "Cancelled": "bg-red-50 text-red-700 border-red-300",
};

export function StatusPill({ status }) {
  const cls = STATUS_STYLES[status] || "bg-zinc-100 text-zinc-700 border-zinc-300";
  return (
    <span className={`inline-flex items-center px-2 py-0.5 text-[11px] font-medium border rounded ${cls}`}
      data-testid={`status-pill-${status}`}>
      {status}
    </span>
  );
}

export function formatCurrency(amount, currency = "EUR") {
  if (amount == null) return "—";
  const symbols = { EUR: "€", USD: "$", GBP: "£", INR: "₹" };
  return `${symbols[currency] || ""}${Number(amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function formatDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
}
